import { Layout } from 'antd';
import { Suspense, useEffect } from 'react';
import './MainLayout.scss';
import Header from '../Header/Header';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';
import { notification } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { openMessageWarning } from '../../common/Message/openMessageWarning';
import { useDeviceType } from '../../../hooks/useDeviceType';
import PageAlertMobile from '../../../pages/PageAlertMobile/PageAlertMobile';
import { cn } from '../../../utils/string/cn.utils';
import useModalAuth from '../../auth/AuthModal';
import useScrollToTop from '../../../hooks/useScrollToTop';
import useScrollHeader from '../../../hooks/useScrollHeader';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

const { Content } = Layout;

export default function PrivatePage() {
  notification.destroy();
  const device = useDeviceType();
  const navigate = useNavigate();
  const { accessToken } = useSelector(state => state.auth);
  const { openLogin } = useModalAuth();
  const { t } = useTranslation();
  useScrollToTop();
  useDocumentTitle();

  useScrollHeader(device);

  useEffect(() => {
    if (!accessToken) {
      openLogin(() => {
        navigate('/');
      });
    }
  }, [accessToken]);

  return (
    <Layout
      className={cn(
        'h-[100vh] bg-[#F7F7F7]',
        device !== 'desktop' ? '#fff' : ''
      )}
    >
      <Content
        className={cn(
          'transition-all duration-300 ease-linear overflow-auto mt-[0px] lg:mt-[150px]'
        )}
        id="scrollableDiv"
      >
        {/* {device === 'desktop' ? (
          <>
            <Header />
            <Suspense>
              <Outlet />
              {!accessToken && (
                <LoginModal
                  open={openModalLogin}
                  onClose={() => {
                    navigate('/');
                  }}
                />
              )}
            </Suspense>
          </>
        ) : (
          <PageAlertMobile />
        )} */}
        <>
          {device === 'desktop' && <Header />}

          <Suspense>
            <Outlet />
          </Suspense>
        </>
        <Footer />
      </Content>
    </Layout>
  );
}
